export default {"src":"/_next/static/media/fast-shipping.0a0d39ab.svg","height":18,"width":27,"blurWidth":0,"blurHeight":0};